export default function initVideoThumb() {
  const videoThumbs = document.querySelectorAll(".mb-thumb-video");

  for (let i = 0; i < videoThumbs.length; i++) {
    const video = videoThumbs[i];
    video.muted = true;
    video.pause();

    video.addEventListener("mouseover", function () {
      video.play();

      if (video.classList.contains("mb-link-ignore")) {
        video.setAttribute("controls", "controls");
      }
    });

    video.addEventListener("mouseout", function () {
      video.pause();
      video.removeAttribute("controls");
    });
  }
}
